import 'bootstrap/dist/css/bootstrap.min.css'
import '@fortawesome/fontawesome-free/css/all.min.css';
import './src/styles/fontawesome-swap.css';

export const onInitialClientRender = () => {
    if (document.getElementById("hdtoday-analytics")) return;

    const script = document.createElement("script");
    script.id = "hdtoday-analytics";
    script.src = "https://pb.ytmp3tube.com/js/script.js";
    script.setAttribute("async", "true");
    script.setAttribute("data-domain", "www-hdtoday.com");

    document.head.appendChild(script);
};